module.exports = __webpack_public_path__ + "static/Dinti-Batsone-843913683eb1a12a5f0d834af0cde4fe.jpg";